export const TOGGLE_PASSWORD_MODAL = "TOGGLE_PASSWORD_MODAL"
export const TOGGLE_ONBOARDING_MODAL = "TOGGLE_ONBOARDING_MODAL"
export const TOGGLE_ASPERA_MODAL = "TOGGLE_ASPERA_MODAL"
